import { Action } from '@ngrx/store';

import { UserActionType } from './user-action-type.enum';

export class UserDetailRequest implements Action {
  public readonly type: UserActionType = UserActionType.UserDetailRequest;

  constructor(public readonly payload: number) { }
}

export class UserDetailRequestRejected implements Action {
  public readonly type: UserActionType = UserActionType.UserDetailRequestRejected;

  constructor(public readonly payload: string) { }
}
